import React, { useMemo, useState } from 'react';
import { normalizeSearchText, filterOptions } from './filterOptions';

function FilterableSelect({
  name,
  options,
  value,
  onChange,
  multiple = false,
  pinnedValues = [],
  placeholderOption = null,
  filterPlaceholder = 'Filtrar...',
  className = '',
  size,
}) {
  const [filterText, setFilterText] = useState('');

  const searchableOptions = useMemo(
    () => options.map((option) => ({ ...option, searchKey: normalizeSearchText(option.label) })),
    [options],
  );

  const selectedValues = useMemo(
    () => (multiple ? (Array.isArray(value) ? value : []) : (value ? [value] : [])),
    [multiple, value],
  );

  const visibleOptions = useMemo(
    () => filterOptions({ options: searchableOptions, filterText, selectedValues, pinnedValues }),
    [searchableOptions, filterText, selectedValues, pinnedValues],
  );

  const handleFilterChange = (event) => setFilterText(event.target.value);
  const handleClearFilter = () => setFilterText('');
  const handleFilterKeyDown = (event) => {
    if (event.key === 'Enter') event.preventDefault();
  };

  return (
    <div className="users-form-filter-wrapper">
      <div className="users-form-filter">
        <input
          type="text"
          className="users-form-filter-input"
          aria-label={filterPlaceholder}
          placeholder={filterPlaceholder}
          value={filterText}
          onChange={handleFilterChange}
          onKeyDown={handleFilterKeyDown}
        />
        {filterText && (
          <button type="button" className="users-form-filter-clear" onClick={handleClearFilter}>
            ×
          </button>
        )}
      </div>
      <select
        className={className}
        name={name}
        multiple={multiple}
        value={value}
        onChange={onChange}
        size={size}
      >
        {!multiple && placeholderOption && (
          <option value={placeholderOption.value}>{placeholderOption.label}</option>
        )}
        {visibleOptions.map((option) => (
          <option key={`${name}-${option.value}`} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <p className="form-help users-form-filter-count">
        Exibindo {visibleOptions.length} de {options.length} item(ns)
      </p>
    </div>
  );
}

export default FilterableSelect;
